import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowLeftIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2207 16.3802L2.80249 9L10.2207 1.61976C10.5931 1.24922 10.5931 0.648444 10.2207 0.277904C9.8482 -0.0926369 9.24434 -0.092635 8.87189 0.277911L0.779335 8.32907C0.406887 8.69962 0.406887 9.30038 0.779335 9.67092L8.87188 17.7221C9.24433 18.0926 9.8482 18.0926 10.2207 17.7221C10.5931 17.3516 10.5931 16.7508 10.2207 16.3802Z"
      fill={fill}
    />
  </svg>
);

export default ArrowLeftIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowLeftIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2207 16.3802L2.80249 9L10.2207 1.61976C10.5931 1.24922 10.5931 0.648444 10.2207 0.277904C9.8482 -0.0926369 9.24434 -0.092635 8.87189 0.277911L0.779335 8.32907C0.406887 8.69962 0.406887 9.30038 0.779335 9.67092L8.87188 17.7221C9.24433 18.0926 9.8482 18.0926 10.2207 17.7221C10.5931 17.3516 10.5931 16.7508 10.2207 16.3802Z"
      fill={fill}
    />
  </svg>
);

export default ArrowLeftIcon;
